import React from 'react';
import styled from 'styled-components';
import Styles from '../CartItem/CartItem.styles';
import Text from '../Text';
import tickets from '../../compound/TicketsWhite/Assets/ico_tickets.svg';
import editIcon from '../../compound/TicketsWhite/Assets/ico_edit.svg';
import deleteIcon from '../../compound/TicketsWhite/Assets/ico_delete.svg';

const Container = styled.div`${Styles.cartTicketsListItem}`;
const Icon = styled.img`${Styles.cartTicketsListItemIcon}`;
const InfoWrapper = styled.div`${Styles.cartTicketsListItemInfoWrapper}`;
const Product = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.cartTicketsListItemProduct}`;
const ActionIcon = styled.img`${Styles.cartTicketsListItemDelete}`;
const Label = styled(Text).attrs({ bold: true })`${Styles.cartTicketsListItemInfoLabel}`;
const InfoText = styled(Text)`${Styles.cartTicketsListItemInfoText}`;
const Row = styled.div`${Styles.cartTicketsListItemInfoRow}`;
const Column = styled.div`${Styles.cartTicketsListItemInfoCol}`;
// eslint-disable-next-line require-jsdoc

const CartItemTicket = ({
  product,
  index,
  locale,
  strings,
  editFn,
  deleteFn
}) => {
  let editBtn = <></>;
  if(editFn) {
    editBtn = <ActionIcon
    onClick={() => {
      editFn(index);
      window.localStorage.setItem('currentFlow', 'Ticket');
    }}
    src={editIcon}
    style={{ marginRight: 10 }}/>
  }
  let deleteBtn = <></>;
  if(deleteFn) {
    deleteBtn = <ActionIcon
    onClick={() => {
      deleteFn(index);
    }}
    src={deleteIcon}/>
  }
  let Item = <></>;
  Item = (
  <Container>
      <Icon src={tickets} />
      <InfoWrapper>
        <Row style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Product style={{ flex: 4 }}>{`${product.NuProdQuant} ${locale === 'es' ? 'boleto' : 'ticket'}${product.NuProdQuant > 1 ? 's' : ''} ${locale === 'es' ? product.DsPublicEs : product.DsPublic}`}</Product>
          {!product.Discount && (
            <Product style={{ flex: 1, textAlign: 'end', flexDirection: 'column' }}>
              <span>{`$${(product.Amount * product.NuProdQuant).toFixed(2)}`}&nbsp;USD</span>
            </Product>
          )
          }
          {!!product.Discount && (
            <Product style={{ flex: 1, textAlign: 'end', flexDirection: 'column' }}>
              <span style={{ textDecoration: 'line-through', color: '#666' }}>{`$${(product.Amount * product.NuProdQuant).toFixed(2)}`}&nbsp;USD</span>
              <span> {`$${(product.Amount * product.NuProdQuant - product.Discount).toFixed(2)}`}&nbsp;USD</span>
            </Product>
          )
          }
        </Row>
        <InfoText>{`${product.NuPassenger} ${product.NuPassenger > 1 ? strings.shoppingLabels.passengers : strings.passenger} $${product.Amount.toFixed(2)}`}</InfoText>
        <Row>
          <Column style={{ flex: 2 }}>
            <Row>
              <Label>{`${strings.from}: `}</Label>
              <InfoText>{` ${product.origin.place}`}</InfoText>
            </Row>
            <Label>{`${strings.departDate}: `}</Label>
            <InfoText>{product.flightDate}</InfoText>
          </Column>
          <Column style={{ flex: 2, alignSelf: 'flex-start' }}>
            <Row>
              <Label>{`${strings.toMayus}: `}</Label>
              <InfoText>{` ${product.destination.place}`}</InfoText>
            </Row>
            <Label>{product.returnDate ? `${strings.returnDate}: ` : ' '}</Label>
            <InfoText>{product.returnDate ? product.returnDate : ' '}</InfoText>
          </Column>
          <Column style={{ flex: 1, marginRight: 0 }}>
            <Row style={{ justifyContent: 'end' }}>
              {editBtn}
              {deleteBtn}
            </Row>
          </Column>
        </Row>
      </InfoWrapper>
    </Container>);
  return Item;
};

export default CartItemTicket;
